const routes = [
  {
    title: "Home",
    slug: "home",
    href: "/",
  },
  {
    title: "Packages",
    slug: "packages",
    href: "/#packages",
  },
  {
    title: "About",
    slug: "about",
    href: "/about",
  },
  {
    title: "Contacts",
    slug: "contacts",
    href: "/contacts",
  }
];

export const routesFooter = [
  {
    title: "Terms & Conditions",
    slug: "terms",
    href: "/terms",
  },
  {
    title: "Privacy Policy",
    slug: "privacy",
    href: "/privacy",
  }
];

export default routes;
